import styled from '@emotion/styled'

import { PRIMARY_FONT_CSS_VAR } from '../../context/CustomizationContextProvider'
import { getTypographyRoleStyle } from '../../style/typography'
import { scaledFontSize } from '../../style/scrollingLayout'

const IN_STOCK_GREEN = '#3D8B5E'

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: IN_STOCK_GREEN,
    fontSize: scaledFontSize(14),
    ...getTypographyRoleStyle('statusText', {
        fontFamily: `var(${PRIMARY_FONT_CSS_VAR})`,
        fontWeight: 500,
        lineHeight: 1.2,
    }),
})

const Dot = styled.span({
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: IN_STOCK_GREEN,
    flexShrink: 0,
})

/**
 * Renders a green dot and "In Stock" label. Intended to sit directly above the
 * Add to cart / Buy now CTAs on PDPs (full-screen, inline, and multi-variant
 * dialog). Render only when the selected variant is available; there is no
 * out-of-stock counterpart because the disabled CTA already communicates that.
 */
export const InStockIndicator = () => {
    return (
        <Container>
            <Dot />
            In Stock
        </Container>
    )
}
